import classNames from "classnames";
import Image from "next/image";
import Hero from "@/components/organisms/Hero";
import Input from "@/components/atoms/Input";
import sendicon from "@/public/images/contact/send.svg";
import ReactDatePicker from "react-datepicker";
import { useState, useEffect } from "react";
import React from "react";
import {
  fieldEmail,
  fieldPhoneNumber,
  fieldRequired,
  fieldName,
  fieldNumbers,
  fieldNumbersAndLetters,
} from "@/utils/validate";
import TextArea from "@/components/atoms/TextArea";
import Button from "@/components/atoms/Button";
import { useTranslation } from "next-i18next";
import { apiEmail, axiosPost } from "@/utils/api";
import moment from "moment";
import ReCAPTCHA from "react-google-recaptcha";

const INIT_FORM = {
  contactName: "",
  //nameOfTheBridge: "",
  weddingDate: "",
  assistants: "",
  rooms: "",
  nights: "",
  country: "",
  city: "",
  phone: "",
  email: "",
  weddingBudget: "",
  spaceRequests: "",
};
const INIT_ERRORS = {
  contactName: "",
  //nameOfTheBridge: "",
  weddingDate: "",
  assistants: "",
  rooms: "",
  nights: "",
  country: "",
  city: "",
  phone: "",
  email: "",
  weddingBudget: "",
  spaceRequests: "",
};

const ContactForm = (props) => {
  const { t } = useTranslation("weddings&groups", "common");
  const [fields, setFields] = useState(INIT_FORM);
  const [errors, setErrors] = useState(INIT_ERRORS);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [validUser, setValidUser] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);
  const recaptchaRef = React.useRef();
  const handleChange = (e) => {
    const { name, value } = e.target;
    handleErrors(name, "");
    setFields((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleErrors = (name, value) => {
    setErrors((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const validateField = (field) => {
    let valid = false;

    switch (field) {
      case "contactName":
        if (!fieldRequired(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-required"));
        } else if (!fieldName(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-name"));
        } else {
          valid = true;
        }
        break;
      // case "weddingDate":
      //   if (!fieldRequired(fields[field])) {
      //     handleErrors(field, t("weddings&groups:form.error-required"));
      //   } else {
      //     valid = true;
      //   }
      //   break;
      case "assistants":
        if (!fieldRequired(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-required"));
        } else if (!fieldNumbers(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-numbers"));
        } else {
          valid = true;
        }
        break;
      case "rooms":
        if (!fieldRequired(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-required"));
        } else if (!fieldNumbers(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-numbers"));
        } else {
          valid = true;
        }
        break;
      case "nights":
        if (!fieldRequired(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-required"));
        } else if (!fieldNumbers(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-numbers"));
        } else {
          valid = true;
        }
        break;
      case "country":
        if (!fieldRequired(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-required"));
        } else if (!fieldName(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-name"));
        } else {
          valid = true;
        }
        break;
      case "city":
        if (!fieldRequired(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-required"));
        } else if (!fieldName(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-name"));
        } else {
          valid = true;
        }
        break;
      case "phone":
        if (!fieldRequired(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-required"));
        } else if (!fieldPhoneNumber(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-phone"));
        } else {
          valid = true;
        }
        break;
      case "email":
        if (!fieldRequired(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-required"));
        } else if (!fieldEmail(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-email"));
        } else {
          valid = true;
        }
        break;
      case "spaceRequests":
        if (!fieldRequired(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-required"));
        } else if (!fieldNumbersAndLetters(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-name"));
        } else {
          valid = true;
        }
        break;
      default:
        if (!fieldRequired(fields[field])) {
          handleErrors(field, t("weddings&groups:form.error-required"));
        } else {
          valid = true;
        }
        break;
    }

    return !valid;
  };
  const onSubmit = async () => {
    setSending(true);
    let eFields = Object.keys(fields).filter((item) => validateField(item));
    console.log(eFields)
    if (!eFields.length && validUser) {
      const response = await axiosPost(apiEmail, {
        data: {
          name: fields.contactName,
          email: fields.email,
          phone: fields.phone,
          info: {
            name: fields.contactName,
            date: moment(fields.weddingDate).format("DD-MM-YYYY"),
            attendants: fields.assistants,
            rooms: fields.rooms,
            nights: fields.nights,
            country: fields.country,
            city: fields.city,
            budget: fields.weddingBudget,
            comments: fields.spaceRequests,
          },
          department: "scsantarosa@goldencancun.com",
          type: "weddings-groups",
        },
      });
      if (response.status === 200 || response.statusText === "OK") {
        setSent(true);
        setSending(false);
      } else {
        setSending(false);
        setSent(false);
      }
    } else {
      setSending(false);
      setSent(false);
    }
  };

  useEffect(() => {
    sent && setFields(INIT_FORM);
    sent && setValidUser(false);
    sent && recaptchaRef.current.reset();
  }, [sending, sent]);
  const onReCAPTCHAChange = async (captchaCode) => {
    if (!captchaCode) {
      return;
    }
    try {
      const response = await fetch("/api/register", {
        method: "POST",
        body: JSON.stringify({ captcha: captchaCode }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.ok) {
        setRecaptchaError(false);
        setValidUser(true);
      } else {
        const error = await response.json();
        throw new Error(error.message);
      }
    } catch (error) {
      console.log(error?.message || "Something went wrong");
    }
  };
  return (
    <section className="bg-white pb-20">
      <div className="bg-main-blue-light pb-20 pt-20 relative">
        <Hero
          title={{
            text: sent
              ? t("weddings&groups:form.msj")
              : t("weddings&groups:form.hero.title"),
            className: "hero-title md:mb-7 text-[28px] lg:text-[50px]",
          }}
          paragraphs={{
            list:
              !sent &&
              t("weddings&groups:form.hero.text", { returnObjects: true }),
            className: "hero-text mb-4 text-center text-[14px] lg:text-[16px]",
          }}
          styles={{
            textContainer: "col-start-2 col-span-10 order-1",
            titleContainer: "col-start-2 col-span-10 order-2",
            paragraphsContainer: "col-start-2 col-span-10 order-3",
          }}
        />
        <div
          className={classNames(
            { hidden: !sent },
            "base-container base-grid py-3"
          )}
        ></div>
        <div
          className={classNames(
            { hidden: sent },
            "base-container base-grid py-3 gap-y-8"
          )}
        >
          <div className="col-span-12 md:col-span-5 md:col-start-2 ">
            <Input
              name="contactName"
              id="contactName"
              placeholder={t("weddings&groups:form.fields.name")}
              value={fields.contactName}
              error={errors?.contactName}
              onChange={handleChange}
            />
          </div>
          <div className="col-span-6 md:col-span-3 ">
            <ReactDatePicker
              dateFormat="dd MMM yyyy "
              selected={fields?.weddingDate}
              minDate={new Date()}
              placeholderText={t("weddings&groups:form.fields.weddingDate")}
              onChange={(date) =>
                handleChange({ target: { name: "weddingDate", value: date } })
              }
              className="cursor-pointer p-1 outline-0 w-full placeholder-medium-grey  bg-transparent rounded-none text-neutral-80 text-base border-main-blue border-b font-subtitle "
            />
            <span className="text-xxs text-red-500 font-text">
              {errors?.weddingDate}
            </span>
          </div>
          <div className="col-span-6 md:col-span-2 ">
            <Input
              name="assistants"
              id="assistants"
              placeholder={t("weddings&groups:form.fields.assistants")}
              value={fields.assistants}
              error={errors?.assistants}
              onChange={handleChange}
              type="number"
            />
          </div>
          <div className=" col-span-6 md:col-span-2 md:col-start-2">
            <Input
              className="placeholder-medium-grey md:mt-2"
              name="rooms"
              id="rooms"
              placeholder={t("weddings&groups:form.fields.rooms")}
              error={errors?.rooms}
              onChange={handleChange}
              value={fields.rooms}
              type="number"
            />
          </div>
          <div className=" col-span-6 md:col-span-2">
            <Input
              className="placeholder-medium-grey md:mt-2"
              name="nights"
              id="nights"
              placeholder={t("weddings&groups:form.fields.nights")}
              error={errors?.nights}
              onChange={handleChange}
              value={fields.nights}
            />
          </div>
          <div className="col-span-12 md:col-span-3">
            <Input
              className="placeholder-medium-grey md:mt-2"
              name="country"
              id="country"
              placeholder={t("weddings&groups:form.fields.country")}
              error={errors?.country}
              onChange={handleChange}
              value={fields.country}
            />
          </div>
          <div className="col-span-12 md:col-span-3">
            <Input
              className="placeholder-medium-grey md:mt-2"
              name="city"
              id="city"
              placeholder={t("weddings&groups:form.fields.city")}
              error={errors?.city}
              onChange={handleChange}
              value={fields.city}
            />
          </div>
          <div className="col-span-12 md:col-span-3 md:col-start-2">
            <Input
              className="placeholder-medium-grey md:mt-2"
              name="phone"
              id="phone"
              placeholder={t("weddings&groups:form.fields.phone")}
              error={errors?.phone}
              onChange={handleChange}
              value={fields.phone}
              type="number"
            />
          </div>
          <div className="col-span-12 md:col-span-4">
            <Input
              className="placeholder-medium-grey md:mt-2"
              name="email"
              id="email"
              placeholder={t("weddings&groups:form.fields.email")}
              error={errors?.email}
              onChange={handleChange}
              value={fields.email}
            />
          </div>
          <div className="col-span-12 md:col-span-3">
            <Input
              className="placeholder-medium-grey md:mt-2"
              name="weddingBudget"
              id="weddingBudget"
              placeholder={t("weddings&groups:form.fields.weddingBudget")}
              error={errors?.weddingBudget}
              onChange={handleChange}
              value={fields.weddingBudget}
            />
          </div>
          <div className="col-span-12 md:col-span-10 md:col-start-2">
            <TextArea
              className="placeholder-medium-grey md:mt-2"
              name="spaceRequests"
              id="spaceRequests"
              placeholder={t("weddings&groups:form.fields.spaceRequests")}
              error={errors?.spaceRequests}
              onChange={handleChange}
              value={fields.spaceRequests}
            />
          </div>
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
            onChange={onReCAPTCHAChange}
            className="mx-auto mt-10 col-span-12"
          />
          <div className="col-span-12 md:col-span-4 md:col-start-5">
            <Button
              id="weddigns-formulario"
              className="cursor-pointer base-button text-white w-full flex justify-center gap-3 items-center hover:opacity-75"
              onClick={(e) => {
                if (!validUser) {
                  setRecaptchaError(true);
                } else {
                  onSubmit(e);
                }
                e.preventDefault();
              }}
              disabled={sending}
            >
              {sending
                ? t("weddings&groups:form.sending")
                : t("weddings&groups:form.send")}
              <Image
                src={sendicon}
                alt="icon"
                className={classNames({ "animate-bounce": sending })}
              />
            </Button>
          </div>
          {recaptchaError && (
              <span className="col-span-12 flex justify-center mt-3 text-xs text-red-500">
                {t('common:recaptcha_error')}
              </span>
          )}
        </div>
      </div>
    </section>
  );
};
export default ContactForm;
